"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPagination = void 0;
function formatPagination(currentPage, pageCount) {
    return `${currentPage.toLocaleString()}/${pageCount.toLocaleString()}`;
}
exports.formatPagination = formatPagination;
